/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./rankactivity.vue?vue&type=template&id=0d0205fc&scoped=true"
import script from "./rankactivity.vue?vue&type=script&lang=js"
export * from "./rankactivity.vue?vue&type=script&lang=js"
import style0 from "./rankactivity.vue?vue&type=style&index=0&id=0d0205fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0205fc",
  null
  
)

export default component.exports